export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  imageContainer: {
    width: "100%",
    height: {
      xs: "200px",
      sm: "200px",
      md: "300px",
    },
    borderRadius: "30px",
    backgroundColor: "#F1F7FA",
    position: "relative",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  selectedImage: {
    width: "100%",
    height: "100%",
    borderRadius: "30px",
    objectFit: "cover",
  },

  dummyImage: {
    width: {
      xs: "50px",
      sm: "54px",
      md: "60px",
      lg: "60px",
      xl: "74px",
    },
    height: {
      xs: "50px",
      sm: "54px",
      md: "60px",
      lg: "60px",
      xl: "74px",
    },
  },

  iconButtonStyle: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    backgroundColor: "#2A4876",
    color: "#FFF",
    width: "32px",
    height: "32px",
    "&:hover": {
      backgroundColor: "#1E3863",
    },
  },

  eventTitleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  labelText: {
    fontSize: "14px",
    textAlign: "left",
    marginBottom: "5px",
  },

  textField: {
    marginBottom: "0px",
    borderRadius: "50px",
    backgroundColor: "#F2F7FB",
    textTransform: "capitalize",
    "& .MuiInputBase-input": {
      color: "#2A4876",
    },
  },

  selectField: {
    displayEmpty: true,
    inputProps: { "aria-label": "Without label" },
    textTransform: "normal",
    "& .MuiInputBase-input": {
      color: "#2A4876",
    },
  },

  datePicker: {
    borderRadius: "50px",
    backgroundColor: "#F2F7FB",
    padding: "0px 14px",
    width: "100%",
    textTransform: "capitalize",
    "& .MuiInputBase-input": {
      color: "#2A4876",
    },
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    "&.Mui-focused fieldset": {
      border: "none",
    },
  },

  timePicker: {
    borderRadius: "50px",
    backgroundColor: "#F2F7FB",
    padding: "0px 14px",
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    "&.Mui-focused fieldset": {
      border: "none",
    },
    width: "100% !important",
    textTransform: "capitalize",
    "& .MuiInputBase-input": {
      color: "#2A4876",
    },
  },
  createButton: {
    marginTop: "10px",
    height: {
      xs: "40px",
      sm: "45px",
      md: "45px",
      lg: "50px",
      xl: "60px",
    },
    width: "100% !important",
    borderRadius: "100px",
    textTransform: "capitalize",
  },
};
